export default __webpack_public_path__ + "static/21-f73da65d0a30450a1ed029fee401b3bc.png";